var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',[_c('Title',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.category.title))]),_c('div',{staticClass:"page-home-category-center"},_vm._l((_vm.items),function(ref,i){
var id = ref.id;
var title = ref.title;
var img = ref.img;
var category = ref.category;
var date = ref.date;
return _c('ArticleCard',{key:i,attrs:{"id":id,"title":title,"img":img,"date":date,"category-title":category.title,"category-color":category.color,"type":"medium"}})}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }